// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./share-channel.styl");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../../../node_modules/style-loader/addStyles.js")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./share-channel.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./share-channel.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/widget/views/desktop/compact/components/share-channel/share-channel.styl
// module id = 2911
// module chunks = 1